import React from "react";
import clsx from "clsx";
import { makeStyles, useTheme } from "@material-ui/core";

const colorTransformations = {
  primary: "primary.main",
  textPrimary: "text.primary",
  secondary: "secondary.main",
  textSecondary: "text.secondary",
  error: "error.main"
};

const transformDeprecatedColors = (theme, color) => {
  const colorKey = colorTransformations[color];
  if (colorKey) {
    return colorKey
      .split(".")
      .reduce((palette, key) => palette[key], theme.palette);
  }
  return color;
};

const useStyles = makeStyles(() => ({
  root: {
    display: "inline-block",
    color: "inherit",
    lineHeight: 0,
    textAlign: "center",
    verticalAlign: "0.5em",
    userSelect: "none",
    textTransform: "none",
    textRendering: "optimizelegibility",
    WebkitFontSmoothing: "antialiased",
    MozOsxFontSmoothing: "grayscale",

    "& svg": {
      display: "inline-block",
      width: "1em",
      height: "1em",
      lineHeight: 1,
      fill: "currentcolor",
      verticalAlign: "top"
    },

    "&.action": {
      tabIndex: 0,
      cursor: "pointer"
    }
  }
}));

const Icon = React.forwardRef(
  (
    { name, className, size, color, style, children, onClick, ...rest },
    ref
  ) => {
    const theme = useTheme();
    color = transformDeprecatedColors(theme, color);
    const styles = { color, fontSize: size, ...style };
    const classes = useStyles();

    return (
      <span
        {...rest}
        role="img"
        aria-label={name}
        tabIndex={!!onClick ? 0 : -1}
        className={clsx(
          classes.root,
          { action: !!onClick },
          "app-icon",
          className
        )}
        onClick={onClick}
        style={styles}
        ref={ref}
      >
        {children}
      </span>
    );
  }
);

export default Icon;
